<maps-drawer *ngIf="open" label="Message history" (closed)="OnClosed()">
    <div drawerTitle class="drawer-heading" data-testid="message-history-drawer">
        <h2>Message history</h2>
        <p class="sub">Every message sent to candidates, with delivery and engagement status.</p>
    </div>

    <p class="none" role="status" *ngIf="isLoading">Loading…</p>

    <p class="none" role="status" *ngIf="!isLoading && batches.length === 0">
        No messages yet — contact a candidate to start a history.
    </p>

    <ul class="list" *ngIf="!isLoading && batches.length > 0">
        <li class="batch" *ngFor="let batch of batches; trackBy: TrackByBatch">
            <div class="batch-head">
                <span class="subject">{{ batch.subject }}</span>
                <span class="meta">
                    <ng-container *ngIf="batch.dateText">{{ batch.dateText }} · </ng-container>
                    {{ batch.recipients.length }} {{ batch.recipients.length === 1 ? 'recipient' : 'recipients' }}
                    <span class="test-badge" data-testid="history-test-badge" *ngIf="batch.isTest">test — not delivered</span>
                </span>
            </div>
            <ul class="recipients">
                <li class="recipient" *ngFor="let r of batch.recipients" [class.failure]="r.isFailure">
                    <span class="name">{{ r.name }}</span>
                    <span class="status">{{ r.statusText }}</span>
                </li>
            </ul>
        </li>
    </ul>

    <button type="button" class="load-more" *ngIf="hasMore" [disabled]="isLoadingMore" (click)="LoadMore()">
        {{ isLoadingMore ? 'Loading…' : 'Load more' }}
    </button>
</maps-drawer>
